window.isDev = Shopify.shop.includes('sandbox');
window.isCC = Shopify.shop.includes('custom-collections-sandbox');
const devData = { // Dev
    storefrontToken: 'ad7a658233fe3bd5298e0e8374cba5f0', //Natori Storefront API
    oosAdminToken: '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', //Discontinued update
    adminToken: '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', //Swatches
    searchSpringId: 'z1kzr1'
};
const ccData = { // Custom Collection Sandbox
    storefrontToken: '4b83d497ef03ef1aaa35315ffdadc5af',//Natori Storefront API
    oosAdminToken: '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', //Collection Inventory
    adminToken: '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', //Swatches-v2
    searchSpringId: 'z1kzr1'
};
const prodData = { // Prod
    storefrontToken: 'e37d6f5fced72df1026762e8fcf43b21',
    oosAdminToken: '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',
    adminToken: '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',
    searchSpringId: 'cr8s7s'
};
Object.entries(window.isCC ? ccData : (window.isDev ? devData : prodData)).forEach(([key, value]) => {
    window[key] = value;
});

window.addEventListener('load', () => {
    const productInfoRights = document.querySelectorAll('.collection-page #ProductGridContainer #product-grid li.column .productInfosection .productInfoRight');
    if (productInfoRights?.length) {
        productInfoRights.forEach((productInfoRight) => {
            const plpRatings = productInfoRight.querySelector('.plpRatings');
            if (plpRatings) {
                const yotpoStar = plpRatings.querySelector('.yotpo .yotpo-bottomline .yotpo-icon-star');
                if (yotpoStar) {
                    plpRatings.classList.add('shown');
                }
            }
        });
    }
});
window.onClick = (selector, callback) => {
    document.body.addEventListener("click", function (e) {
        const target = e.target;
        if (target.matches(selector)) {
            callback(target);
        }
    });
};
window.onClick('.swatch-btn', (target) => {
    let productCard = target.closest(".card-wrapper");
    productCard.querySelectorAll(".swatch-btn").forEach(btn => btn.classList.remove("active"));
    target.classList.add("active");

    let newSrc = target.getAttribute("data-src");
    let newSrcset = target.getAttribute("data-srcset");
    let newSrcAlt = target.getAttribute("data-srcalt");
    let newSrcsetAlt = target.getAttribute("data-srcsetalt");
    let newUrl = target.getAttribute("data-url");
    let newPrice = target.getAttribute("data-price");

    // Update product link
    if (newUrl) {
        productCard.querySelectorAll("a").forEach(link => link.setAttribute("href", newUrl));
    }

    // Update primary image
    let primaryImage = productCard.querySelector(".product-primary-image");
    if (primaryImage && newSrc) {
        primaryImage.setAttribute("src", newSrc);
        if (newSrcset) {
            primaryImage.setAttribute("srcset", newSrcset);
        }
    }

    // Update secondary image
    let secondaryImage = productCard.querySelector(".product-secondary-image");
    if (secondaryImage) {
        if (newSrcAlt) {
            secondaryImage.setAttribute("src", newSrcAlt);
        }
        if (newSrcsetAlt) {
            secondaryImage.setAttribute("srcset", newSrcsetAlt);
        }
    }

    // Update price if available
    if (newPrice) {
        const priceElement = productCard.querySelector(".price__regular .price-item");
        if (priceElement) {
            priceElement.innerHTML = newPrice;
        }
        const salePriceElement = productCard.querySelector(".price__sale .price-item--sale");
        if (salePriceElement) {
            salePriceElement.innerHTML = newPrice;
        }
    }
});